import { TranslationStore } from "./translation-store";

export class TransTokens {
  public static create = TranslationStore.setTokens;

  public static getTranslation = TranslationStore.getTranslation;
}
